import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserError, getUserStatus } from "../store/slices/userSlice";
import $ from "jquery";
import "datatables.net";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import { addSpecies, deleteSpecie, editSpecie, getSpecies, addSeason, getAllSeason, editSeason, deleteSeason } from "../store/featureActions";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "30%",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    padding: "0px",
  },
};
Modal.setAppElement("#root");
const AllSeasons = () => {
  const [id, setId] = useState();
  const [seasonName, setSeasonName] = useState("");
  const [seasonStart, setSeasonStart] = useState("");
  const [seasonEnd, setSeasonEnd] = useState("");
  const dispatch = useDispatch();
  const status = useSelector(getUserStatus);
  const error = useSelector(getUserError);
  const [seasonList, setSeasonList] = useState(null);
  const [detail, setDetail] = useState(null);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState();
  const navigate = useNavigate();
  function viewModal(item, type) {
    setIsOpen(true);
    if (type == "detail") {
      setDetail(item);
    } else if (type == "create") {
      setId(item);
    } else if (type == "delete") {
      setId(item);
    } else if (type == "edit") {
      setDetail(item);
      setId(item?._id);
      setSeasonName(item?.seasonName);
      setSeasonStart(item?.seasonStart);
      setSeasonEnd(item?.seasonEnd);
    }
    setModalType(type);
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
    setSeasonName("");
    setSeasonStart("");
    setSeasonEnd("");
  }
  const seasonDelete = async (id) => {
    try {
      let payload = {
        params: id,
        isToast: true,
      };
      await dispatch(deleteSeason(payload)).unwrap();
      setIsOpen(false);
      $("#tableData").DataTable().destroy();
      seasonsList();
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };

  const Seasons = async () => {
    let payload = {
      body: {
        seasonName,
        seasonStart,
        seasonEnd,
      },
      params: false,
      isToast: true,
    };
    try {
      if (seasonName?.trim()?.length < 1) {
        toast.error("Season name field can't be empty");
      } else if (!seasonStart) {
        toast.error("Season Start field can't be empty");
      } else if (seasonStart < moment(new Date()).format("YYYY-MM-DD")) {
        toast.error("Start Date must be greater than current date");
      } else if (!seasonEnd) {
        toast.error("Season End field can't be empty");
      } else if (seasonEnd <= seasonStart) {
        toast.error("End date must be greater than start date");
      } else {
        await dispatch(addSeason(payload)).unwrap();
        setIsOpen(false);
        if (seasonList) {
          $("#tableData").DataTable().destroy();
        }
        seasonsList();
        closeModal();
      }
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };

  const seasonEdit = async (id) => {
    let payload = {
      body: {
        seasonName,
        seasonStart,
        seasonEnd,
      },
      params: id,
      isToast: true,
    };
    try {
      if (seasonEnd <= seasonStart) {
        toast.error("End date must be greater then start date");
      } else {
        await dispatch(editSeason(payload)).unwrap();
        setIsOpen(false);
        if (seasonList) {
          $("#tableData").DataTable().destroy();
        }
        seasonsList();
        closeModal();
      }
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };

  const seasonsList = async () => {
    try {
      setSeasonList(null);
      let payload = {
        params: false,
        isToast: false,
      };
      const response = await dispatch(getAllSeason(payload)).unwrap();
      setSeasonList(response?.data?.seasons);
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };
  useEffect(() => {
    let mount = true;
    if (mount) {
      seasonsList();
    }
    return () => {
      mount = false;
    };
  }, []);
  useEffect(() => {
    if (seasonList) {
      $("#tableData").DataTable({
        lengthMenu: [10, 25, 50, 100, 200],
        language: {
          emptyTable: "Specie List Not Found",
        },
        destroy: true,
      });
    }
  }, [seasonList]);
  return (
    <>
      <Modal closeTimeoutMS={500} isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Change Password">
        <div className="change-password-modal" id="exampleModalCenter" tabIndex={-1} aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block", zIndex: 100 }}>
          {modalType == "create" ? (
            <>
              <div className="headerModal">
                <p className="pass-text">Add Season</p>
                <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="input-group input-group-sm mb-2 w-100">
                  <input type="text" maxLength={25} className="form-control" placeholder="Enter Season Name" aria-label="Season Name" onChange={(e) => setSeasonName(e.target.value)} />
                </div>
                <form className="form-floating my-2">
                  <input type="date" min={moment(new Date()).format("YYYY-MM-DD")} className="form-control" id="floatingInputValue" value={seasonStart} placeholder="dd-mm-yyyy" onChange={(e) => setSeasonStart(e.target.value)} />
                  <label for="floatingInputValue">Season Start Date</label>
                </form>
                <form className="form-floating my-2">
                  <input type="date" min={moment(new Date()).format("YYYY-MM-DD")} className="form-control" id="floatingInputValue" value={seasonEnd} placeholder="dd-mm-yyyy" onChange={(e) => setSeasonEnd(e.target.value)} />
                  <label for="floatingInputValue">Season End Date</label>
                </form>
                <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={Seasons}>
                  Create
                </button>
              </div>
            </>
          ) : modalType == "edit" ? (
            <>
              <div className="headerModal">
                <p className="pass-text">Edit Season</p>
                <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="input-group input-group-sm mb-2 w-100">
                  <input type="text" maxLength={25} className="form-control" placeholder="Enter Season Name" aria-label="Season Name" value={seasonName} onChange={(e) => setSeasonName(e.target.value)} />
                </div>
                <form className="form-floating my-2">
                  <input type="date" min={moment(new Date()).format("YYYY-MM-DD")} className="form-control" id="floatingInputValue" value={moment(seasonStart, "YYYY-MM-DD").format("YYYY-MM-DD")} placeholder="dd-mm-yyyy" onChange={(e) => setSeasonStart(e.target.value)} />
                  <label for="floatingInputValue">Season Start Date</label>
                </form>
                <form className="form-floating my-2">
                  <input type="date" min={moment(new Date()).format("YYYY-MM-DD")} className="form-control" id="floatingInputValue" value={moment(seasonEnd, "YYYY-MM-DD").format("YYYY-MM-DD")} placeholder="dd-mm-yyyy" onChange={(e) => setSeasonEnd(e.target.value)} />
                  <label for="floatingInputValue">Season End Date</label>
                </form>
                <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={() => seasonEdit(id)}>
                  Update
                </button>
              </div>
            </>
          ) : modalType == "delete" ? (
            <>
              <div className="headerModal">
                <p className="pass-text">Delete Season Confirmation</p>
                <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <form>
                  <div className="pass-form-wrap" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                    <div className="login-button mt-2" style={{ width: "40%" }}>
                      <button type="button" onClick={() => seasonDelete(id)} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">
                        Delete
                      </button>
                    </div>
                    <div className="login-button mt-2" style={{ width: "40%" }}>
                      <button type="button" onClick={closeModal} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </Modal>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: seasonList ? "3%" : "12%",
        }}
      >
        <section className="coupon-sec-2">
          <div className="container tableContainer">
            <div className=" mt-2 mb-3 d-flex justify-content-end">
              <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} onClick={() => viewModal(null, "create")}>
                Add Season
              </button>
            </div>
          </div>
        </section>
        <section className="coupon-sec-2">
          <div className="container tableContainer">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="card shadow mb-4">
                  <div className="card-body">
                    <div className="table-responsive" id="tableready">
                      <table id="tableData" className="table table-bordered display" style={{ width: "100%", textAlign: "center" }}>
                        <thead>
                          {seasonList ? (
                            <tr>
                              <th>S.No</th>
                              <th>Season Name</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Status</th>
                              <th>Players Ranking</th>
                              <th>Action</th>
                            </tr>
                          ) : (
                            <tr></tr>
                          )}
                        </thead>
                        <tbody>
                          {seasonList?.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{item?.seasonName}</td>
                                <td>{moment(item?.seasonStart, "YYYY-MM-DD").format("MM-DD-YYYY")}</td>
                                <td>{moment(item?.seasonEnd, "YYYY-MM-DD").format("MM-DD-YYYY")}</td>
                                <td>
                                  <span className="edit-icon">
                                    <span style={{ fontWeight: "bold", margin: 10, textAlign: "center" }}>{item?.isStarted == 0 && item?.isEnded == 0 ? "Upcoming" : item?.isStarted == 1 && item?.isEnded == 0 ? "Active" : item?.isEnded == 1 ? "Past" : ""}</span>
                                  </span>
                                </td>
                                <td>
                                  <span className="edit-icon">
                                    {item?.isStarted == 0 ? (
                                      <span style={{ fontWeight: "bold", margin: 10 }}>Season Not Started Yet</span>
                                    ) : (
                                      <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={(e) => navigate(`/players-ranking/${item?._id}`)}>
                                        View
                                      </span>
                                    )}
                                  </span>
                                </td>
                                <td>
                                  <span className="edit-icon">
                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item, "edit")}>
                                      <i className="fa fa-solid fa-edit"></i> Edit
                                    </span>
                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item?._id, "delete")}>
                                      <i className="fas fa-trash-alt"></i> Delete
                                    </span>
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        {!seasonList ? (
                          status == "loading" || error ? (
                            <tfoot>
                              <tr>
                                <th>{status == "loading" ? "Loading..." : error ? error : ""}</th>
                              </tr>
                            </tfoot>
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default AllSeasons;
